import React, { useEffect, useState } from "react";
import AdminAppBar from "../adminComponents/AdminAppBar";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LeadDetail from "./LeadDetail";
import LeadDeals from "./LeadDeals";
import LeadHistory from "./LeadHistory";
import LeadNotesHistory from "./LeadNotesHistory";
import LeadDbService from "../Services/LeadDbService";
import { toast } from "react-toastify";
import { BsFire } from "react-icons/bs";
import useHotLeads from "../../hooks/useHotLeads";
import HotLeadHistoryModel from "../HotLeadComponent/HotLeadHistoryModel";
import { userRole } from '../../utils/storage'

const LeadInfo = () => {
  const navigate = useNavigate();
  const { leadId } = useParams();

  const [leadTeamName, setLeadTeamName] = useState("");
  const [leadUserName, setLeadUserName] = useState("");

  const location = useLocation();

  const leadAssignStatus = location?.state?.assignStatus;
  const handleBack = () => {
    window.history.back();
  };

  const { handleLeadHotHistory, leadHotHistotyData, isOpen, setIsOpen } =
    useHotLeads();

  const handleReassign = () => {
    if (userRole === "Admin") {
      navigate(`/admin/lead/reassign`, {
        state: {
          leadTeam: leadTeamName,
          leadUser: leadUserName,
          leadId: leadId,
        },
      });
    } else if (userRole === "CMO") {
      navigate(`/cmo/lead/reassign`, {
        state: {
          leadTeam: leadTeamName,
          leadUser: leadUserName,
          leadId: leadId,
        },
      });
    } else if (userRole === "BOD") {
      navigate(`/bod/lead/reassign`, {
        state: {
          leadTeam: leadTeamName,
          leadUser: leadUserName,
          leadId: leadId,
        },
      });
    }
  };

  const path = userRole === "Admin" ? '/admin' : userRole === "CMO" ? '/cmo' : '/bod';

  const handelAssign = () => {
    navigate(`${path}/lead/reassign`, {
      state: {
        leadSourceId: lead?.leadSourceId,
        assignStatus: true,
        leadCount: 1,
        teamId: lead?.teamId,
        leadId: leadId,
      },
    });
  };

  const [lead, setLead] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await LeadDbService.fetchLeadById(leadId);
        console.log("Lead Data:", response.data);
        setLead(response.data);
        setLeadTeamName(response.data?.assignedTeam);
        setLeadUserName(response.data?.assignedUser);
      } catch (error) {
        console.error("Error fetching lead data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("Lead data fetched", location?.state);

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message, {
        position: "top-center",
        theme: "light",
        className: "absolute top-20",
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);
  return (
    <div className="bg-appGrayBackground  ">
      <AdminAppBar />

      <div className="h-full  py-28  ">
        <div className="px-8 flex  pt-2  items-center ">
          <div className="">
            <svg
              onClick={handleBack}
              className=" cursor-pointer relative  md:w-5 md:h-7 lg:w-5 lg:h-9"
              width="20"
              height="34"
              viewBox="0 0 22 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                fill="#399E79"
              />
            </svg>
          </div>

          <div className="flex justify-between w-full ">
            <div className="font-semibold md:mx-0 cursor-default  lg:mx-6 md:text-2xl mx-14 lg:text-4xl ">
              Lead Info
            </div>

            <div className="flex items-center gap-4">
      {/* { (userRole === "Admin" || userRole === "CMO")   &&   <div
                onClick={() => handleLeadHotHistory(leadId)}
                className="bg-white cursor-pointer flex items-center justify-center gap-2 text-base text-[#EE6C4D] font-medium s w-full rounded-[10px] p-2"
              >
                <BsFire className="text-xl" />
                <div>Hot Lead History</div>
              </div>} */}

              {console.log("Lead Info:", lead?.assignedUser)}
              {lead?.assignedUser != "Unassigned" && (
                <>
                  {(userRole === "Admin" || userRole === "CMO" || userRole === "BOD") && (
                    <button
                      onClick={handleReassign}
                      disabled={
                        lead?.status === "Dealing" ||
                        lead?.status === "Registered Client"
                      }
                      className={`h-10 ${
                        lead?.status === "Dealing" ||
                        lead?.status === "Registered Client"
                          ? "bg-gray-500"
                          : "bg-customGreen"
                      } cursor-pointer text-white p-2 rounded-md mr-12`}
                    >
                      Reassign
                    </button>
                  )}
                </>
              )}

              {lead?.assignedUser === "Unassigned" && (
                <button
                  onClick={handelAssign}
                  className={`h-10 ${
                    lead?.status === "Dealing"
                      ? "bg-gray-500"
                      : "bg-customGreen"
                  } cursor-pointer text-white p-2 rounded-md mr-12`}
                >
                  Assign
                </button>
              )}
            </div>
          </div>
        </div>

        <div className=" px-20 mt-4 flex gap-12 xl:gap-5 ">
          <div className="w-6/12">
            <LeadDetail lead={lead} />
          </div>
          <div className="flex flex-col w-6/12 gap-5">
            <LeadDeals docId={leadId} />
            <LeadHistory docId={leadId} />
            <LeadNotesHistory docId={leadId} />
          </div>
        </div>
      </div>
      <HotLeadHistoryModel
        isOpen={isOpen}
        selectedLeaddata={leadHotHistotyData}
        isClose={() => {
          setIsOpen(false);
        }}
      />
    </div>
  );
};

export default LeadInfo;
